export default __webpack_public_path__ + "icon_wifi.47b0e96b6e5ce7cb9b91617e18b66eb0.svg";